import { publicApi } from '../api';

const VISITOR_KEY = 'bce_visitor_id';

// Identifiant anonyme persistant (localStorage) — sert uniquement à compter les visiteurs
// uniques, aucune donnée personnelle n'est associée.
export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function trackEvent(eventType, path) {
  publicApi.post('analytics', {
    event_type: eventType,
    visitor_id: getVisitorId(),
    path: path ?? window.location.pathname,
  }).catch(() => {});
}

export const trackPageview        = (path) => trackEvent('pageview', path);
export const trackInscriptionClick = ()    => trackEvent('inscription_click');
